import * as React from 'react'

function SvgGf(props) {
	return (
		<svg viewBox="0 0 3 2" width="1em" height="1em" {...props}>
			<path fill="#ED2939" d="M0 0h3v2H0z" />
			<path fill="#fff" d="M0 0h2v2H0z" />
			<path fill="#002395" d="M0 0h1v2H0z" />
		</svg>
	)
}

export default SvgGf
